import {
  SEARCH_INPUT_CHANGED,
  DOCUMENTATION_SEARCH_STARTED,
  DOCUMENTATION_SEARCH_SUCCESS,
  DOCUMENTATION_SEARCH_FAILIED,
  RESET_FOUND_DOCUMENTATION,
} from './types';

import { fetchDocumentation as fetchDocumentationApi } from '../../../../shared/api';

import { fetchingError } from '../../../../../shared/store/actions';
import { errorNotification } from '../../../../../shared/store/notificationActions';

export const searchInputChanged = text => async dispatch => {
  dispatch({
    type: SEARCH_INPUT_CHANGED,
    text,
  });
};

export const searchForDocumentation = searchText => async dispatch => {
  try {
    dispatch({
      type: DOCUMENTATION_SEARCH_STARTED,
      searchText,
    });
    const foundDocumentation = await fetchDocumentationApi(searchText);
    dispatch({
      type: DOCUMENTATION_SEARCH_SUCCESS,
      foundDocumentation,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: DOCUMENTATION_SEARCH_FAILIED,
      });
      return;
    }
    throw error;
  }
};

export const resetFoundDocumentation = () => async dispatch => {
  dispatch({
    type: RESET_FOUND_DOCUMENTATION,
  });
};
